// Mock database of customs declarations for verification
export const declarations = {
  "101-01292611-26": {
    dec_no: "101-01292611-26",
    dec_barcode: "351101821719",
    dec_date: "24/07/2026",
    dec_type: "IMPORT",
    dec_type_ar: "استيراد",
    dec_subtype: "Import to Local from ROW",
    port_type: "AIR",
    port_type_ar: "جوي",
    delivery_order_no: "",
    importer_code: "PC01276286",
    importer_name: "GANDHI DJUNA",
    carrier_captain: "",
    intercessor_code: "AE-1000021",
    intercessor_name: "DNATA CARGO",
    gross_weight: "2272",
    gross_weight_unit: "kg",
    carrier_name: "EK9390",
    commercial_reg_no: "",
    measurement: "",
    voyage_no: "EK9390",
    tin_no: "",
    no_of_packages: "1 UNIT",
    marks_numbers: "LAMBORGHINI URUS PERFORMANTE // CHASSIS NO:ZPBEC3ZL5RLA37531 // MODEL YEAR:2025 // COLOR GREY NARDO // INVOICE NO INV-2026-0703-001",
    exported_to: "",
    port_of_loading: "MADRID",
    port_of_discharge: "DWC ALMAKTOUM CARGO",
    destination: "",
    bill_awb_no: "17687415720",
    bill_awb_loc: "LOC. DWC AlMaktoum Cargo Terminal",
    bill_awb_pr: "PR-00466/Emirates Sky Cargo DWC",
    goods: [
      {
        hs_code: "87032490",
        description: "LAMBORGHINI URUS  PERFORMANTE",
        origin: "IT",
        foreign_value: "260000.00",
        currency_code: "EUR",
        currency_rate: "4.1924",
        cif_local_aed: "1090024.00",
        d_rate: "5.0",
        income_type: "DEF",
        total_duty_aed: "54501.20",
      },
    ],
    packages: { qty: "", type: "", unit: "u", net: "", gross: "2272 kg", item: "1", no: "", duty: "", aip: "" },
    customs_restrictions: { agency: "", release_ref: "" },
    exemption_code: "",
    aed_totals: {
      total_duty: "54501",
      vat: "",
      excise_tax: "",
      anti_dumping: "",
      handling: "",
      other_charges: "70",
      definite: "54571",
      insured: "",
      total_fee: "",
      payment_method: "DUTY 54501.20 [4504710] CA-1060764\nRGCH 50.00 [4504711] CA-1060764\nKDID 20.00 [4504712] CA-1060764",
    },
    clearing_agent_code: "AE-1182693",
    clearing_agent_name: "DGX GLOBAL FREIGHT L.L.C",
    clearing_agent_licence: "1298967",
    unified_customs_code: "",
    gcc_aeo_code: "",
    other_remarks: "[CIF] FRT: INS:\nTotal Value: 1090024.00112\nCustoms Inspection Required",
    exit_port: "",
    stamp_text: "",
    footer_ref: "dgxglobal1",
    footer_date: "25/07/2026",
    page: "Page 1 of 1",
    receipt_details: {
      date: "",
      bank: "",
      receipt_no: "",
    },
  },
  "101-01285443-26": {
    dec_no: "101-01285443-26",
    dec_barcode: "351101821720",
    dec_date: "18/07/2026",
    dec_type: "IMPORT",
    dec_type_ar: "استيراد",
    dec_subtype: "Import to Local from ROW",
    port_type: "SEA",
    port_type_ar: "بحري",
    delivery_order_no: "DO-88291",
    importer_code: "PC01100221",
    importer_name: "AL MARWAN GENERAL TRADING",
    carrier_captain: "CAPT. J. ROSSI",
    intercessor_code: "AE-1000045",
    intercessor_name: "DP WORLD JEBEL ALI",
    gross_weight: "18450",
    gross_weight_unit: "kg",
    carrier_name: "MSC MARIA",
    commercial_reg_no: "CR-772891",
    measurement: "32.4 CBM",
    voyage_no: "MSC-VY-2288E",
    tin_no: "100221886500003",
    no_of_packages: "420 CTNS",
    marks_numbers: "HOME APPLIANCES // SAMSUNG BRAND // ASSORTED MODELS // INV NO INV-2026-0611-118",
    exported_to: "",
    port_of_loading: "BUSAN",
    port_of_discharge: "JEBEL ALI PORT",
    destination: "DUBAI",
    bill_awb_no: "MSCUAB889221",
    bill_awb_loc: "LOC. Jebel Ali Container Terminal",
    bill_awb_pr: "PR-77120/DP World JAP",
    goods: [
      {
        hs_code: "84181020",
        description: "REFRIGERATOR - SIDE BY SIDE",
        origin: "KR",
        foreign_value: "52400.00",
        currency_code: "USD",
        currency_rate: "3.6725",
        cif_local_aed: "192438.70",
        d_rate: "5.0",
        income_type: "DEF",
        total_duty_aed: "9621.94",
      },
      {
        hs_code: "84501100",
        description: "WASHING MACHINE - AUTOMATIC",
        origin: "KR",
        foreign_value: "28900.00",
        currency_code: "USD",
        currency_rate: "3.6725",
        cif_local_aed: "106135.25",
        d_rate: "5.0",
        income_type: "DEF",
        total_duty_aed: "5306.76",
      },
    ],
    packages: { qty: "420", type: "CTN", unit: "pcs", net: "17820", gross: "18450 kg", item: "2", no: "", duty: "", aip: "" },
    customs_restrictions: { agency: "", release_ref: "" },
    exemption_code: "",
    aed_totals: {
      total_duty: "14929",
      vat: "14928",
      excise_tax: "",
      anti_dumping: "",
      handling: "120",
      other_charges: "",
      definite: "29977",
      insured: "",
      total_fee: "29977",
      payment_method: "DUTY 14929.00 [4504810] CA-1060811",
    },
    clearing_agent_code: "AE-1180221",
    clearing_agent_name: "SWIFT CLEARANCE SERVICES L.L.C",
    clearing_agent_licence: "1211887",
    unified_customs_code: "UCC-77281",
    gcc_aeo_code: "",
    other_remarks: "Verified",
    exit_port: "JEBEL ALI",
    stamp_text: "VERIFIED",
    footer_ref: "swiftcls1",
    footer_date: "19/07/2026",
    page: "Page 1 of 1",
    receipt_details: {
      date: "18/07/2026",
      bank: "ENBD",
      receipt_no: "RC-8827192",
    },
  },
  "101-01301188-26": {
    dec_no: "101-01301188-26",
    dec_barcode: "351101821721",
    dec_date: "22/07/2026",
    dec_type: "EXPORT",
    dec_type_ar: "تصدير",
    dec_subtype: "Export to ROW from Local",
    port_type: "SEA",
    port_type_ar: "بحري",
    delivery_order_no: "",
    importer_code: "PC01188229",
    importer_name: "EMIRATES DATES FACTORY",
    carrier_captain: "CAPT. A. HASSAN",
    intercessor_code: "AE-1000102",
    intercessor_name: "DP WORLD JEBEL ALI",
    gross_weight: "22500",
    gross_weight_unit: "kg",
    carrier_name: "MAERSK DUBAI",
    commercial_reg_no: "CR-882110",
    measurement: "28.6 CBM",
    voyage_no: "MRK-VY-1141W",
    tin_no: "100118822900003",
    no_of_packages: "1100 CTNS",
    marks_numbers: "PREMIUM DATES // KHALAS VARIETY // 5KG BOX // BATCH 2026-EX-042",
    exported_to: "UNITED KINGDOM",
    port_of_loading: "JEBEL ALI PORT",
    port_of_discharge: "FELIXSTOWE",
    destination: "LONDON",
    bill_awb_no: "MAEU887321",
    bill_awb_loc: "LOC. Jebel Ali Export Terminal",
    bill_awb_pr: "PR-88221/DP World JAP",
    goods: [
      {
        hs_code: "08041000",
        description: "DATES - KHALAS PREMIUM",
        origin: "AE",
        foreign_value: "84500.00",
        currency_code: "USD",
        currency_rate: "3.6725",
        cif_local_aed: "310326.13",
        d_rate: "0.0",
        income_type: "EXP",
        total_duty_aed: "0.00",
      },
    ],
    packages: { qty: "1100", type: "CTN", unit: "kg", net: "22000", gross: "22500 kg", item: "1", no: "", duty: "", aip: "" },
    customs_restrictions: { agency: "", release_ref: "" },
    exemption_code: "",
    aed_totals: {
      total_duty: "0",
      vat: "0",
      excise_tax: "",
      anti_dumping: "",
      handling: "90",
      other_charges: "",
      definite: "90",
      insured: "",
      total_fee: "90",
      payment_method: "HANDLING 90.00 [4504911] CA-1060900",
    },
    clearing_agent_code: "AE-1188221",
    clearing_agent_name: "AL FALAH CLEARING L.L.C",
    clearing_agent_licence: "1288221",
    unified_customs_code: "UCC-88291",
    gcc_aeo_code: "AEO-AE-7712",
    other_remarks: "Cleared for Export",
    exit_port: "JEBEL ALI",
    stamp_text: "CLEARED",
    footer_ref: "alfalah1",
    footer_date: "22/07/2026",
    page: "Page 1 of 1",
    receipt_details: {
      date: "22/07/2026",
      bank: "ADCB",
      receipt_no: "RC-9922177",
    },
  },
};

export const findDeclaration = (decNo, decDate) => {
  const cleaned = (decNo || "").trim();
  const rec = declarations[cleaned];
  if (!rec) return null;
  if (decDate && rec.dec_date !== decDate.trim()) return null;
  return rec;
};

export const listDeclarations = () => Object.values(declarations);
